import {
  //
  GET_PREVIEW,
  GET_PREVIEW_SUCCESS,
  GET_PREVIEW_FAILURE,
  //
  GET_TEMPLATE_DATA,
  GET_TEMPLATE_DATA_SUCCESS,
  GET_TEMPLATE_DATA_FAILURE,
  //
  SAVE_TEMPLATE_DATA,
  SAVE_TEMPLATE_DATA_SUCCESS,
  SAVE_TEMPLATE_DATA_FAILURE,
  //
  UPLOAD_FILE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  //
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE,
  //
  SEARCH_TEMPLATES,
  SEARCH_TEMPLATES_SUCCESS,
  SEARCH_TEMPLATES_FAILURE,
  //
  GET_CARE_SUMMARY,
  GET_CARE_SUMMARY_SUCCESS,
  GET_CARE_SUMMARY_FAILURE,
  //
  GET_VERSION_DATA,
  GET_VERSION_DATA_SUCCESS,
  GET_VERSION_DATA_FAILURE,
  //
  UPDATE_TEMPLATE_DATA,
  UPDATE_TEMPLATE_DATA_SUCCESS,
  UPDATE_TEMPLATE_DATA_FAILURE,
  //
  SAVE_SNAPSHOT,
  SAVE_SNAPSHOT_SUCCESS,
  SAVE_SNAPSHOT_FAILURE,
  //
  GET_OBSERVATIONS,
  GET_OBSERVATIONS_SUCCESS,
  GET_OBSERVATIONS_FAILURE,
  //
  DELETE_VERSION,
  DELETE_VERSION_SUCCESS,
  DELETE_VERSION_FAILURE,
  //
  GET_CURRENT_TEMPLATE,
  GET_CURRENT_TEMPLATE_SUCCESS,
  GET_CURRENT_TEMPLATE_FAILURE,
  //
  SAVE_OBSERVATION,
  SAVE_OBSERVATION_SUCCESS,
  SAVE_OBSERVATION_FAILURE,
  //
  ADD_TEMPLATE_DATA,
  ADD_TEMPLATE_DATA_SUCCESS,
  ADD_TEMPLATE_DATA_FAILURE,
  //
  GET_REVISION,
  GET_REVISION_SUCCESS,
  GET_REVISION_FAILURE,
  //
  VIEW_REVISION,
  VIEW_REVISION_SUCCESS,
  VIEW_REVISION_FAILURE,
  //
  GET_GOVERNANCE_STATS,
  GET_GOVERNANCE_STATS_SUCCESS,
  GET_GOVERNANCE_STATS_FAILURE,
  //
  UPDATE_PLAN_STATUS,
  UPDATE_PLAN_STATUS_SUCCESS,
  UPDATE_PLAN_STATUS_FAILURE,
} from "./constants";

// List
export const getPreview = (payload, onSuccess) => ({
  type: GET_PREVIEW,
  payload,
  onSuccess,
});
export const getPreviewSuccess = (payload) => ({
  type: GET_PREVIEW_SUCCESS,
  payload,
});
export const getPreviewFailure = (payload) => ({
  type: GET_PREVIEW_FAILURE,
  payload,
});

// Template Data
export const getTemplateData = (payload, onSuccess) => ({
  type: GET_TEMPLATE_DATA,
  payload,
  onSuccess,
});
export const getTemplateDataSuccess = (payload) => ({
  type: GET_TEMPLATE_DATA_SUCCESS,
  payload,
});

export const getTemplateDataFailure = (payload) => ({
  type: GET_TEMPLATE_DATA_FAILURE,
  payload,
});

// Save Template Data
export const saveTemplateData = (payload, onSuccess) => ({
  type: SAVE_TEMPLATE_DATA,
  payload,
  onSuccess,
});
export const saveTemplateDataSuccess = (payload) => ({
  type: SAVE_TEMPLATE_DATA_SUCCESS,
  payload,
});
export const saveTemplateDataFailure = (payload) => ({
  type: SAVE_TEMPLATE_DATA_FAILURE,
  payload,
});

// Upload File
export const uploadFile = (payload, onSuccess) => ({
  type: UPLOAD_FILE,
  payload,
  onSuccess,
});
export const uploadFileSuccess = (payload) => ({
  type: UPLOAD_FILE_SUCCESS,
  payload,
});
export const uploadFileFailure = (payload) => ({
  type: UPLOAD_FILE_FAILURE,
  payload,
});

// Delete File
export const deleteFile = (payload, onSuccess) => ({
  type: DELETE_FILE,
  payload,
  onSuccess,
});
export const deleteFileSuccess = (payload) => ({
  type: DELETE_FILE_SUCCESS,
  payload,
});
export const deleteFileFailure = (payload) => ({
  type: DELETE_FILE_FAILURE,
  payload,
});

// Search Templates
export const searchTemplates = (payload, onSuccess) => ({
  type: SEARCH_TEMPLATES,
  payload,
  onSuccess,
});
export const searchTemplatesSuccess = (payload) => ({
  type: SEARCH_TEMPLATES_SUCCESS,
  payload,
});
export const searchTemplatesFailure = (payload) => ({
  type: SEARCH_TEMPLATES_FAILURE,
  payload,
});

// Get Care Summary
export const getCareSummary = (payload, onSuccess) => ({
  type: GET_CARE_SUMMARY,
  payload,
  onSuccess,
});
export const getCareSummarySuccess = (payload) => ({
  type: GET_CARE_SUMMARY_SUCCESS,
  payload,
});
export const getCareSummaryFailure = (payload) => ({
  type: GET_CARE_SUMMARY_FAILURE,
  payload,
});

// Get Version Data
export const getVersionData = (payload, onSuccess) => ({
  type: GET_VERSION_DATA,
  payload,
  onSuccess,
});
export const getVersionDataSuccess = (payload) => ({
  type: GET_VERSION_DATA_SUCCESS,
  payload,
});
export const getVersionDataFailure = (payload) => ({
  type: GET_VERSION_DATA_FAILURE,
  payload,
});

// Update Template Data
export const updateTemplateData = (payload, onSuccess) => ({
  type: UPDATE_TEMPLATE_DATA,
  payload,
  onSuccess,
});
export const updateTemplateDataSuccess = (payload) => ({
  type: UPDATE_TEMPLATE_DATA_SUCCESS,
  payload,
});
export const updateTemplateDataFailure = (payload) => ({
  type: UPDATE_TEMPLATE_DATA_FAILURE,
  payload,
});

// Save Snapshot
export const saveSnapshot = (payload, onSuccess) => ({
  type: SAVE_SNAPSHOT,
  payload,
  onSuccess,
});
export const saveSnapshotSuccess = (payload) => ({
  type: SAVE_SNAPSHOT_SUCCESS,
  payload,
});
export const saveSnapshotFailure = (payload) => ({
  type: SAVE_SNAPSHOT_FAILURE,
  payload,
});

// Get Observations
export const getObservations = (payload, onSuccess) => ({
  type: GET_OBSERVATIONS,
  payload,
  onSuccess,
});
export const getObservationsSuccess = (payload) => ({
  type: GET_OBSERVATIONS_SUCCESS,
  payload,
});
export const getObservationsFailure = (payload) => ({
  type: GET_OBSERVATIONS_FAILURE,
  payload,
});

// Delete Version
export const deleteVersion = (payload, onSuccess) => ({
  type: DELETE_VERSION,
  payload,
  onSuccess,
});
export const deleteVersionSuccess = (payload) => ({
  type: DELETE_VERSION_SUCCESS,
  payload,
});
export const deleteVersionFailure = (payload) => ({
  type: DELETE_VERSION_FAILURE,
  payload,
});

// Get Assessment Data
export const getCurrentTemplate = (payload, onSuccess) => ({
  type: GET_CURRENT_TEMPLATE,
  payload,
  onSuccess,
});
export const getCurrentTemplateSuccess = (payload) => ({
  type: GET_CURRENT_TEMPLATE_SUCCESS,
  payload,
});
export const getCurrentTemplateFailure = (payload) => ({
  type: GET_CURRENT_TEMPLATE_FAILURE,
  payload,
});

// Save Observation
export const saveObservation = (payload, onSuccess) => ({
  type: SAVE_OBSERVATION,
  payload,
  onSuccess,
});
export const saveObservationSuccess = (payload) => ({
  type: SAVE_OBSERVATION_SUCCESS,
  payload,
});
export const saveObservationFailure = (payload) => ({
  type: SAVE_OBSERVATION_FAILURE,
  payload,
});

// Add Template Data
export const addTemplateData = (payload, onSuccess) => ({
  type: ADD_TEMPLATE_DATA,
  payload,
  onSuccess,
});
export const addTemplateDataSuccess = (payload) => ({
  type: ADD_TEMPLATE_DATA_SUCCESS,
  payload,
});
export const addTemplateDataFailure = (payload) => ({
  type: ADD_TEMPLATE_DATA_FAILURE,
  payload,
});

// Get Revision
export const getRevision = (payload, onSuccess) => ({
  type: GET_REVISION,
  payload,
  onSuccess,
});
export const getRevisionSuccess = (payload) => ({
  type: GET_REVISION_SUCCESS,
  payload,
});
export const getRevisionFailure = (payload) => ({
  type: GET_REVISION_FAILURE,
  payload,
});

// View Revision
export const viewRevision = (payload, onSuccess) => ({
  type: VIEW_REVISION,
  payload,
  onSuccess,
});
export const viewRevisionSuccess = (payload) => ({
  type: VIEW_REVISION_SUCCESS,
  payload,
});
export const viewRevisionFailure = (payload) => ({
  type: VIEW_REVISION_FAILURE,
  payload,
});

// Get Governance Stats
export const getGovernanceStats = (payload, onSuccess) => ({
  type: GET_GOVERNANCE_STATS,
  payload,
  onSuccess,
});
export const getGovernanceStatsSuccess = (payload) => ({
  type: GET_GOVERNANCE_STATS_SUCCESS,
  payload,
});
export const getGovernanceStatsFailure = (payload) => ({
  type: GET_GOVERNANCE_STATS_FAILURE,
  payload,
});

// Update Plan Status
export const updatePlanStatus = (payload, onSuccess) => ({
  type: UPDATE_PLAN_STATUS,
  payload,
  onSuccess,
});
export const updatePlanStatusSuccess = (payload) => ({
  type: UPDATE_PLAN_STATUS_SUCCESS,
  payload,
});
export const updatePlanStatusFailure = (payload) => ({
  type: UPDATE_PLAN_STATUS_FAILURE,
  payload,
});
